
<div class="flex">
    <div class="data">{{displayMessage}}</div>
    <div class="my-snack-bar" *ngIf="data?.orderId && data.orderId !== ''">      
      <button class="copy-btn" (click)="copyToClipboard()">Copy ID</button>
    </div>
    <div class="dismiss">
      <button class="close-btn" (click)="snackBarRef?.dismiss()">
          ×
        </button>
    </div>
</div>